module.exports = __webpack_public_path__ + "img/quiddler.fa2f7841.jpg";